import { BrowserRouter } from 'react-router-dom';
import { createBrowserHistory } from 'history';

const clientBasePath = process.env.REACT_APP_CLIENT_BASE_PATH;

export const history = createBrowserHistory(
    { basename: clientBasePath }
);

export default class YourBrowserRouter extends BrowserRouter {
    history;
}



// WEBPACK FOOTER //
// ./src/utils/History.js